export default "__VITE_ASSET__DiQ_ijXM__"